/**
 * Focuses the given HTMLElement and moves the caret to the end of its content.
 *
 * @param el HTMLElement to focus and move caret to the end
 */
export const focusAndMoveCaretToEnd = (el: HTMLElement) => {
  el.focus()
  const range = document.createRange()
  range.selectNodeContents(el)
  range.collapse(false) // Move to end

  const sel = window.getSelection()
  sel?.removeAllRanges()
  sel?.addRange(range)
}

/**
 * Converts HTML content from a contentEditable element to plain text.
 * - Replaces <br>, <div> and <p> tags with newlines
 * - Strips all other HTML tags
 *
 * @param html The HTML string to convert
 * @returns The processed text content
 */
export const contentEditableToText = (html: string): string => {
  const container = document.createElement('div')
  container.innerHTML = html

  const lines: string[] = []

  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      lines.push((node as Text).data)
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement
      const tag = el.tagName.toLowerCase()

      if (tag === 'br') {
        lines.push('\n')
      } else if (['div', 'p'].includes(tag)) {
        lines.push('\n')
        Array.from(el.childNodes).forEach(walk)
      } else {
        Array.from(el.childNodes).forEach(walk)
      }
    }
  }

  Array.from(container.childNodes).forEach(walk)

  // Combine and clean up
  return lines
    .join('')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
